module.exports = __webpack_public_path__ + "static/media/searchdark.49ca111d.svg";